import * as React from "react";
import { styled } from "theme";

export interface Props {
  price: number;
  active?: boolean;
}

export default function Price({ price, active }: Props) {
  let [left, right] = splitPrice(price);
  return (
    <PriceContainer>
      <EuroSign>&euro;</EuroSign>
      <Natural className={active ? "active" : "idle"}>{left}</Natural>
      <Decimals>{right !== "" ? `,${right}` : ""}</Decimals>
    </PriceContainer>
  );
}

const PriceContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: ${(props) => props.theme.colors.gray["400"]};
`;

const EuroSign = styled.div`
  font-size: 20px;

  @media (max-width: 400px) {
    font-size: 14px;
  }
`;

const Natural = styled.div`
  font-size: 20px;
  text-align: right;
  &.active {
    color: #333;
    font-weight: bold;
  }
`;

const Decimals = styled.div`
  font-size: 10px;
  padding-bottom: 8px;
  flex: 0 0 18px;
  text-align: right;
  color: ${(props) => props.theme.colors.gray["500"]};
  display: none;
`;

function splitPrice(n: number): [string, string] {
  let left = Math.floor(n);
  let right = n - left;
  right = Math.floor(right * 100);

  return [left + "", right + ""];
}
